
export default function Footer() {
  return (
    <footer className="bg-[#2C3E2D] text-white py-16">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <h3 
                className="text-2xl font-normal text-white mb-6 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Nova <span className="italic">Conciergerie</span>
              </h3>
              <p 
                className="text-white/80 mb-6 leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Votre partenaire de confiance pour la gestion de locations saisonnières dans les Pyrénées-Orientales. Nous mettons notre expertise au service de votre tranquillité d'esprit.
              </p>
              <div className="flex space-x-4">
                <a 
                  href="#" 
                  className="w-10 h-10 flex items-center justify-center bg-[#6B7C59] rounded-full hover:bg-[#5A6B49] transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-white"></i>
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 flex items-center justify-center bg-[#6B7C59] rounded-full hover:bg-[#5A6B49] transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-white"></i>
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 flex items-center justify-center bg-[#6B7C59] rounded-full hover:bg-[#5A6B49] transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-white"></i>
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 
                className="text-lg font-normal text-white mb-6 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Nos Services
              </h4>
              <ul className="space-y-3">
                <li>
                  <a 
                    href="#services" 
                    className="text-white/80 hover:text-white transition-colors font-light tracking-wide cursor-pointer"
                    style={{ fontFamily: '"Montserrat", sans-serif' }}
                  >
                    Gestion locative
                  </a>
                </li>
                <li>
                  <a 
                    href="#services" 
                    className="text-white/80 hover:text-white transition-colors font-light tracking-wide cursor-pointer"
                    style={{ fontFamily: '"Montserrat", sans-serif' }}
                  >
                    Ménage & entretien
                  </a>
                </li>
                <li>
                  <a 
                    href="#services" 
                    className="text-white/80 hover:text-white transition-colors font-light tracking-wide cursor-pointer"
                    style={{ fontFamily: '"Montserrat", sans-serif' }}
                  >
                    Accueil voyageurs
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 
                className="text-lg font-normal text-white mb-6 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Contact
              </h4>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#6B7C59]/20 rounded-full">
                    <i className="ri-mail-line text-[#6B7C59]"></i>
                  </div>
                  <span className="text-white/80 font-light" style={{ fontFamily: '"Montserrat", sans-serif' }}>contact@conciergerienova.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#6B7C59]/20 rounded-full">
                    <i className="ri-phone-line text-[#6B7C59]"></i>
                  </div>
                  <span className="text-white/80 font-light" style={{ fontFamily: '"Montserrat", sans-serif' }}>06 50 42 86 25</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#6B7C59]/20 rounded-full">
                    <i className="ri-map-pin-line text-[#6B7C59]"></i>
                  </div>
                  <span className="text-white/80 font-light" style={{ fontFamily: '"Montserrat", sans-serif' }}>Perpignan, France</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom */}
          <div className="border-t border-white/10 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p 
                className="text-white/60 font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                © 2024 Nova Conciergerie. Tous droits réservés.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="nofollow"
                className="text-white/60 hover:text-white transition-colors mt-4 md:mt-0 font-light cursor-pointer"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
